
































import Vue from 'vue'
import _ from 'lodash'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore } from '@/store'
import CompendiumCard from './components/CompendiumCard.vue'

export default Vue.extend({
  name: 'compendium-cards-view',
  components: { CompendiumCard },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selected: null,
  }),
  computed: {
    compendium() {
      return getModule(CompendiumStore, this.$store)
    },
    sources() {
      if (!this.items.some(x => !x.Source)) {
        const sources = _.uniq(this.items.map(x => x.Source))
        return sources.map((x: string) =>
        {
          const s = this.compendium.Manufacturers.find(y => y.ID === x.toUpperCase())
          return s || x
        }
        )
      }
      return ['']
    },
  },
  methods: {
    itemsBySource(s) {
      if (!s) return this.items
      return this.items.filter(x => x.Source === s)
    },
  },
})
